import { render } from "./ConfigurationsHeader.vue?vue&type=template&id=af621fb8&scoped=true"
import script from "./ConfigurationsHeader.vue?vue&type=script&lang=js"
export * from "./ConfigurationsHeader.vue?vue&type=script&lang=js"

import "./ConfigurationsHeader.vue?vue&type=style&index=0&id=af621fb8&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af621fb8"]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox});
